<div class="app_check_box">
    <label class="d-inline-flex align-items-center" [class.line_through]="DisabledLineThrough" [class.disabled]="disabled" [for]="Name">
        <input 
            [id]="Name"
            [name]="Name"
            type="checkbox"
            [value]="value"
            class="float-start"
            [disabled]="disabled"
            (blur)="markAsTouched()"
            (change)="change($event)"
            [class.disabled]="disabled"
            [checked]="value ? (control?.value == value) : control?.value"
        />
        {{label || 'المسمي'}} <ng-container *ngIf="MarkAsRequired"><span class="marked_required text-danger">*</span></ng-container>
    </label>    

    <ng-container *ngIf="validatorsErrorMsg">
        <ng-container *ngTemplateOutlet="ErrorTemp" />
    </ng-container>

    <ng-template #ErrorTemp>
        <div class="clearfix"></div>
        <p class="invalid text_md_bold" *ngIf="ErrorMsg && control?.touched" [innerHTML]="ErrorMsg || ''" ></p>        
    </ng-template>

</div>